import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

export default function NewArrivalProductCard({ product }) {
  const navigate = useNavigate();

  // Ensure product exists with default values to prevent errors
  const safeProduct = product || {};

  const buyNow = () => {
    if (safeProduct.id) {
      navigate(`/product/${safeProduct.id}`);
    }
  };

  return (
    <>
      {/* Inline CSS for animations */}
      <style>
        {`
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes sparkle {
            0% { opacity: 0; transform: translateX(-100%); }
            50% { opacity: 1; }
            100% { opacity: 0; transform: translateX(100%); }
          }
          .animate-fadeInUp {
            animation: fadeInUp 1s ease-out forwards;
          }
          .animate-sparkle {
            position: absolute;
            inset: 0;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
            animation: sparkle 2s infinite;
          }
          .hover-glow {
            transition: all 0.3s ease;
          }
          .hover-glow:hover {
            box-shadow: 0 0 25px rgba(212, 175, 55, 0.6);
          }
        `}
      </style>

      <div className="relative w-full max-w-md mx-auto animate-fadeInUp">
        {/* Card Container - Made larger */}
        <div className="relative bg-white rounded-md overflow-hidden border border-gray-100 hover-glow transition-all duration-300 group">
          {/* Image Container - Increased height */}
          <div className="relative w-full h-96"> {/* Changed from h-64 to h-96 */}
            <Link to={safeProduct.id ? `/product/${safeProduct.id}` : "#"}>
              <img
                src={safeProduct.images?.[0] || "/api/placeholder/400/320"}
                alt={safeProduct.name || "Product Image"}
                className="w-full h-full object-cover"
              />
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
            </Link>

            {/* New Arrival Badge - Made larger */}
            <div className="absolute top-5 left-5 bg-[#D4AF37] text-black text-sm font-bold px-4 py-1.5 rounded-full z-10">
              <span className="relative">
                New Arrival
                <span className="animate-sparkle"></span>
              </span>
            </div>

            {/* Content Overlay - Increased padding and font sizes */}
            <div className="absolute bottom-0 left-0 right-0 p-6 text-center z-10">
              {/* Product Name - Larger text */}
              <Link to={safeProduct.id ? `/product/${safeProduct.id}` : "#"}>
                <h3 className="text-xl font-semibold text-white mb-2 truncate">
                  {safeProduct.name || "Product Name"}
                </h3>
              </Link>

              {/* Price Section - Larger text */}
              <div className="flex items-center justify-center gap-2 mb-2">
                <span className="text-2xl font-bold text-white">
                  ₹{safeProduct.prices?.["30ml"] || "N/A"}
                </span>
              </div>

              {/* Fragrance Note - Larger text */}
              <div className="mb-4">
                <span className="text-[#D4AF37] text-sm font-medium">
                  {safeProduct.fragranceNotes?.join(", ") || "Fragrance notes not available"}
                </span>
              </div>

              {/* Button - Larger with more padding */}
              <button 
                onClick={buyNow}
                className="w-full bg-[#D4AF37] text-black py-3 px-6 rounded-md text-base font-medium hover:bg-[#C19B2E] transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2"
              >
                <ShoppingBag className="w-5 h-5" />
                Buy Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}